/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const styles = {
  container: css({
    
  }),

  types: css({
    columnGap: 16,
    padding: '12px 0',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',

    ':before': {
      display: 'none',
    },

    ':after': {
      display: 'none',
    }
  }),

  type: css({
    flexGrow: 1,
    width: '100%',
    outline:      'none',
    border:       'none',
    fontWeight:   '400',
    fontSize:     '14px',
    lineHeight:   '24px',
    display:      'flex',
    alignItems:  'center',
    justifyContent: 'left',
    borderRadius: 5,
    gap: '8px',
    padding:      '12px 16px',
    color:     'rgb(0, 0, 0)',
    backgroundColor: 'rgb(255, 255, 255)',
    boxShadow: '0 0 0 1px inset rgb(0, 0, 0)',
    transition: 'color .2s, background-color .2s, box-shadow .2s',

    'span': {
      fontSize: '16px',
      lineHeight: '24px'
    },

    ':hover': {
      boxShadow: '0 0 0 2px inset rgb(0, 0, 0)',
    }
  }),

  active: css({
    color: 'rgb(0, 0, 0)',
    backgroundColor: 'rgba(246, 241, 233, 1)',
    boxShadow: '0 0 0 2px inset rgb(224, 168, 55)',
  })
}